let modals = require('sma.common/components/modals');

const deleteTemplates = {
	deleteDialog: require('sma.common/partials/delete_dialog.mustache'),
	cancelDeleteDialog: require('sma.common/partials/cancel_delete_dialog.mustache')
};

export function accountDeleteDialog(options) {
	let modalBody = $(deleteTemplates.deleteDialog({
		strings: options.strings,
		sites: options.sites
	}));

	let dialogButtons = [{
		label: gettext('CANCEL'),
		cls: 'btn-link',
		handler(modal) {
			modal.hide();
		}
	}, {
		label: gettext('DELETE'),
		cls: 'btn-danger sma-js-delete-dialog-delete-button disabled',
		handler: options.handler
	}];

	modalBody.find('.sma-js-delete-dialog-delete-button').attr('disabled', 'disabled');

	let validateButtonState = (e) => {
		let checked = modalBody.find('.sma-js-account-delete-confirm').is(':checked');
		let hasPassword = modalBody.find('input[type="password"]').val().trim().length;

		if (checked && hasPassword) {
			$('.sma-js-delete-dialog-delete-button').removeClass('disabled').removeAttr('disabled');
		} else {
			$('.sma-js-delete-dialog-delete-button').addClass('disabled').attr('disabled', 'disabled');
		}
	};

	modalBody.on('change', '.sma-js-account-delete-confirm', validateButtonState);
	modalBody.on('input', 'input[type="password"]', validateButtonState);

	let modal = new modals.ContentModal(
		modalBody,
		{
			title: options.title,
			destroyOnClose: true,
			autoShow: true,
			buttons: dialogButtons
		}
	);
}

export function cancelAccountDeletionDialog(options) {
	let dialogButtons = [{
		label: gettext('NO, KEEP DELETION REQUEST'),
		cls: 'btn-link',
		handler(modal) {
			modal.hide();
		}
	}, {
		label: gettext('YES, CANCEL DELETION'),
		cls: 'btn-primary',
		id: 'sma-js-cancel-account-deletion',
		handler: options.handler
	}];

	let modalBody = deleteTemplates.cancelDeleteDialog({
		strings: options.strings
	});

	let modal = new modals.ContentModal(
		modalBody,
		{
			title: options.title,
			destroyOnClose: true,
			autoShow: true,
			buttons: dialogButtons
		}
	);
}